var map = {
	"./ball.png": "ab14",
	"./basketball-match.png": "1951",
	"./comment.png": "d6d2",
	"./event.png": "934b",
	"./football-match.png": "a9a5",
	"./match.png": "d74a",
	"./speaker.png": "480a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2d59";